<div class="container-full bg-gradient">
    <form id="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-card>
            <img src="assets/logo-inline.png" class="logo"/>
            <h1 class="free-trial">
                Heureux de vous revoir !
            </h1>
            <mat-card-content>
                <app-alert></app-alert>
                <div class="btns_social">
                    <a class="btn btn-facebook" (click)="signInWithFB()">
                        <img src="/assets/logo-facebook.avif"/>
                    </a>
                    <a class="btn btn-google" (click)="signInWithGoogle()">
                        <img src="/assets/Google_icon-icons.com_66793.png"/>
                    </a>
                </div>
                <hr class="ou">

                <div *ngIf="forgotMsg == '1'" class="alert alert-success">
                    Mot de passe modifié, vous pouvez maintenant vous connecter.
                </div>
                <div *ngIf="forgotMsg == '2'" class="alert alert-success">
                    Un compte existe déjà avec ce mail, veuillez vous connecter.
                </div>

                <div class="form-group">
                    <mat-form-field>
                        <mat-label>E-mail</mat-label>
                        <input matInput formControlName="username" placeholder="E-mail" class="text">
                        <mat-error
                            *ngIf="loginForm.get('username').invalid">{{formService.getErrorMessage(loginForm.get('username'))}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <mat-form-field class="pb-0">
                        <mat-label>Mot de passe</mat-label>
                        <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" class="text">
                        <p mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                           [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </p>
                        <mat-error  *ngIf="loginForm.get('password').invalid">{{formService.getErrorMessage(loginForm.get('password'))}}</mat-error>
                    </mat-form-field>
                    <p class="lost-password">
                        <a [routerLink]="['/app/forgotPassword']">Mot de passe oublié</a>
                    </p>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button class="btn btn-primary w-100" [disabled]="loginForm.invalid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Valider
                </button>
                <p class="mt-2">
                    Vous n'êtes pas inscrit ?
                    <a [routerLink]="['/app/register']" [queryParams]="{returnUrl: returnUrl}">Inscrivez-vous</a>
                </p>
            </mat-card-actions>
        </mat-card>
    </form>
</div>
